import React, { Component } from "react";
import {
  Table,
  Container
} from "reactstrap";
import swal from "sweetalert";
import { connect } from "react-redux";
import { Authorization } from "./../../../utils/Authorization";
import Loading from "./../../utils/Loading";
import { ModalArchivos } from "./../../utils/ModalArchivos";
import { ModalDevolucionMonitoreo } from "./../../utils/ModalDevolucionMonitoreo";
import {
  getAdminMonitoreoActividad,
  getMonitoreoActividad,
  updateMonitoreoActividad,
} from "./../../../redux/actions/monitoreo-actividad-actions";
import { getListMonitoreoMediosVerificacion } from "./../../../redux/actions/monitoreo_medios_verificacion_actions";
import {mostrarPoa,mostrarPoas,getPoaActivo} from "./../../../redux/actions/poa-actions";
import { getAreasOrganizacionales } from "./../../../redux/actions/areas-actions"; //me
import { ModalCriteriosEvaluacionMonitoreo } from "../../utils/ModalCriteriosEvaluacionMonitoreo";
import { getCriterios } from "../../../redux/actions/criterio_evaluacion_actions";
import {
  truncateString,
  getSemaforoStyle,
  resultadoToNumber,
  poaUsaPuntuacion,
  esCriterioAusenciaDemanda,
  evaluacionEsAusenciaDemanda,
  CRITERIO_AUSENCIA_DEMANDA_ID,
} from "../../../utils/utils";
import {
  actualizarMonitoreoEvaluacion,
  getMonitereoEvaluadas,
  guardarMonitoreoEvaluacion,
  getMonitereoEvaluacionCriteriosById,
} from "../../../redux/actions/monitoreo-evaluacion";

class AreaMonitoreo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingState: true,
      isLoadingModalArchivo:true,
      modalArchivos: false,
      monitoreoMediosVerificacion: [],
      modalDevolucion: false,
      modalCriteriosEvaluacion: false,
      monitoreo: {},
      comentarioHistorial: "",
      areaidSeleccionada:0,
      adminMonitoreoActividadState: [],
      criterios: [],
      monitoreosAprobados: [],
    };
  }
  filtroAreaRef = new React.createRef();
  componentDidMount() {
    this.cargarDatos();

    this.props.getAreasOrganizacionales();
    this.props.getCriterios();
    this.props.getMonitereoEvaluadas();
    this.setState({
      areaidSeleccionada:
        this.props.user.areaOrganizacional.areaOrganizacionalId,
    });
  }

  filtrarMonitoreosListado = (monitoreos = []) => {
    return monitoreos.filter((monitoreo) => {
      const nivelAprobacionId = Number(monitoreo.nivelAprobacionId);
      return nivelAprobacionId === 4 || nivelAprobacionId === 5;
    });
  };

  filtroProducto = (productosName) => {
    const monitoreosListado = this.filtrarMonitoreosListado(
      this.props.adminMonitoreoActividad
    );
    const filtroProducto = monitoreosListado.filter((productos) =>
      productos.producto.toUpperCase().includes(productosName.toUpperCase())
    );

    this.setState({ adminMonitoreoActividadState: filtroProducto });
  };

  cargarDatos = async (area = 0) => {
    await this.props.getAdminMonitoreoActividad(
      this.props.poaActivo.poaId,
      this.props.user.areaOrganizacional.areaOrganizacionalId
    );
    this.setState({
      isLoadingState: false,
      areaInformesTrimestrales: this.props.areasInformesTrimestrales,
      adminMonitoreoActividadState: this.filtrarMonitoreosListado(
        this.props.adminMonitoreoActividad
      ),
    });
  };

  cargarData = async (poaId, area = 0) => {
    this.setState({ isLoadingState: true });
    await this.props.getAdminMonitoreoActividad(poaId, area);

    await this.props.mostrarPoa(poaId, area);
    await this.props.getMonitereoEvaluadas();
    this.setState({ isLoadingState: false });
    this.setState({
      adminMonitoreoActividadState: this.filtrarMonitoreosListado(
        this.props.adminMonitoreoActividad
      ),
    });
  };

  filtroAreaOrganizacional = () => {
    if (
      this.filtroAreaRef.current === null ||
      this.filtroAreaRef.current.value === null ||
      this.filtroAreaRef.current.value === ""
    ) {
      this.setState({
        areaInformesTrimestrales: this.props.areasInformesTrimestrales,
      });
    } else {
      let filtroAreaInformeTrimestral = this.props.areasInformesTrimestrales.filter(
        (area) =>
          area.areaOrganizacional.nombre
            .toUpperCase()
            .includes(this.filtroAreaRef.current.value.toUpperCase())
        );
      this.setState({ areaInformesTrimestrales: filtroAreaInformeTrimestral });
    }
  };

  activarModalArchivos =  (monitoreoMediosVerificacion) => {
    this.setState({
      modalArchivos: !this.state.modalArchivos,
      isLoadingModalArchivo: true,
      monitoreoMediosVerificacion,
    });
  };


  activarModalDevolucionMonitoreo = (monitoreo) => {
    this.setState({
      modalDevolucion: !this.state.modalDevolucion,
      monitoreo,
    });
  };

  obtenerMonitoreoConDetalle = async (monitoreo) => {
    if (!monitoreo?.monitoreoId) return monitoreo;

    try {
      const resultado = await this.props.getMonitoreoActividad(
        monitoreo.monitoreoId
      );
      const detalle = Array.isArray(resultado) ? resultado[0] : resultado;

      return {
        ...monitoreo,
        ...(detalle || {}),
      };
    } catch (error) {
      return monitoreo;
    }
  };

  activarModalCriteriosEvaluacionMonitoreo = (monitoreo) => {
    this.setState({
      modalCriteriosEvaluacion: !this.state.modalCriteriosEvaluacion,
      monitoreo,
    });
  };

  monitoreoFueAprobado = (monitoreo) => {
    return Number(monitoreo.nivelAprobacionId) === 5;
  };

  aprobarMonitoreo = async (monitoreo) => {
    const nivelActual = Number(
      this.props.user.nivelAprobacion.nivelAprobacionId
    );
    const nivelAprobacionPadre = 5;

    if (
      !Number.isInteger(nivelAprobacionPadre) ||
      nivelAprobacionPadre <= nivelActual
    ) {
      swal(
        "Error de aprobación",
        "El nivel de aprobación padre debe ser mayor que el nivel actual.",
        "error"
      );
      return;
    }

    swal({
      title: "¿Está seguro de aprobar este monitoreo?",
      text: "Una vez aprobado no podrá ser editado nuevamente!",
      icon: "warning",
      buttons: ["Cancelar", "Aceptar"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        this.setState({ isLoadingState: true });
        const monitoreoDetalle = await this.obtenerMonitoreoConDetalle(monitoreo);
  
        const monitoreoActividadentity = {
          actualizadoPor: this.props.user.id,
          monitoreoId: monitoreoDetalle.monitoreoId,
          productoId: monitoreoDetalle.productoId,
          actividadId: monitoreoDetalle.actividadId,
          nivelAprobacionId: nivelAprobacionPadre,
          nivelEjecucion: monitoreoDetalle.nivelEjecucion,
          comentario: monitoreoDetalle.comentario || "",
          accionesMedidas:
            monitoreoDetalle.accionesMedidas ||
            monitoreoDetalle.AccionesMedidas ||
            "",
          AccionesMedidas:
            monitoreoDetalle.accionesMedidas ||
            monitoreoDetalle.AccionesMedidas ||
            "",
          envio: true,
          trimestre: monitoreoDetalle.trimestre,
          creadoPor: this.props.user.id,
          comentarioHistorial: `El monitoreo de la actividad ${monitoreoDetalle.actividad} fue aprobado`,
        };
  
        const fd = new FormData();
        Object.keys(monitoreoActividadentity).forEach((item) => {
          fd.append(item, monitoreoActividadentity[item]);
        });
  
        try {
          await this.props.updateMonitoreoActividad(fd);
          this.setState((prevState) => ({
            adminMonitoreoActividadState: prevState.adminMonitoreoActividadState.map((item) =>
              item.monitoreoId === monitoreo.monitoreoId
                ? {
                    ...item,
                    nivelAprobacionId: nivelAprobacionPadre,
                    aprobadoEnVista: true,
                    comentarioHistorial:
                      monitoreoActividadentity.comentarioHistorial,
                  }
                : item
            ),
            monitoreosAprobados: [
              ...new Set([...prevState.monitoreosAprobados, monitoreo.monitoreoId]),
            ],
          }));
  
          swal({
            title: "¡Aprobado!",
            text: "El monitoreo fue enviado con éxito.",
            icon: "success",
          });
  
        } catch (error) {
          console.error("Error en aprobación:", error);
        } finally {
          this.setState({ isLoadingState: false });
        }
      }
    });
  };

  CriteriosEvaluacionMonitoreo = async (monitoreo, comentarioHistorial) => {
    this.setState({
      isLoadingState: true,
      modalCriteriosEvaluacion: !this.state.modalCriteriosEvaluacion,
    });
    const monitoreoDetalle = await this.obtenerMonitoreoConDetalle(monitoreo);

    const monitoreoActividadentity = {
      monitoreoActividadId: monitoreoDetalle.monitoreoId,
      productoId: monitoreoDetalle.productoId,
      actividadId: monitoreoDetalle.actividadId,
      nivelEjecucion: monitoreoDetalle.nivelEjecucion,
      comentario: monitoreoDetalle.comentario || "",
      accionesMedidas:
        monitoreoDetalle.accionesMedidas ||
        monitoreoDetalle.AccionesMedidas ||
        "",
      AccionesMedidas:
        monitoreoDetalle.accionesMedidas ||
        monitoreoDetalle.AccionesMedidas ||
        "",
      nivelAprobacionId: 3,
      envio: true,
      trimestre: monitoreoDetalle.trimestre,
      comentarioHistorial:
        "El monitoreo de la actividad " +
        monitoreoDetalle.actividad +
        " fue devuelto debido a que " +
        comentarioHistorial,
    };

    await this.props.updateMonitoreoActividad(monitoreoActividadentity);
    this.setState({ isLoadingState: false });
  };

  devolverMonitoreo = async (monitoreo, comentarioHistorial) => {
    const nivelAprobacionId = Number(monitoreo.nivelAprobacionId);

    if (!Number.isInteger(nivelAprobacionId) || nivelAprobacionId <= 0) {
      swal(
        "Error en devolución",
        "El monitoreo no tiene un nivel de aprobación válido.",
        "error"
      );
      return;
    }

    this.setState({
      isLoadingState: true,
      modalDevolucion: !this.state.modalDevolucion,
    });
    const monitoreoDetalle = await this.obtenerMonitoreoConDetalle(monitoreo);

    const monitoreoActividadentity = {
      actualizadoPor: this.props.user.id,
      monitoreoId: monitoreoDetalle.monitoreoId, 
      productoId: monitoreoDetalle.productoId,
      actividadId: monitoreoDetalle.actividadId,
      nivelEjecucion: monitoreoDetalle.nivelEjecucion,
      comentario: monitoreoDetalle.comentario || "",
      accionesMedidas:
        monitoreoDetalle.accionesMedidas ||
        monitoreoDetalle.AccionesMedidas ||
        "",
      AccionesMedidas:
        monitoreoDetalle.accionesMedidas ||
        monitoreoDetalle.AccionesMedidas ||
        "",
      nivelAprobacionId: 3,
      envio: true,
      trimestre: monitoreoDetalle.trimestre,
      comentarioHistorial: `El monitoreo de la actividad ${monitoreoDetalle.actividad} fue devuelto debido a que ${comentarioHistorial}`,
    };
  
    const fd = new FormData();
    Object.keys(monitoreoActividadentity).forEach((item) => {
      fd.append(item, monitoreoActividadentity[item]);
    });
  
    try {
      await this.props.updateMonitoreoActividad(fd);
      
      swal({
        title: "¡Devuelto!",
        text: "El monitoreo ha sido devuelto correctamente.",
        icon: "info",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error("Error en devolución:", error);
    } finally {
      this.setState({ isLoadingState: false });
    }
  };
  
  cargarMonitoreoMediosVerificacion = async (monitoreo) => {
    let monitoreoMediosVerificacion = [];
    this.activarModalArchivos([]);
    await this.props.getListMonitoreoMediosVerificacion(monitoreo.monitoreoId);
    monitoreoMediosVerificacion = this.props.monitoreoMediosVerificacion;

    this.setState({
      monitoreoMediosVerificacion,
      isLoadingModalArchivo: false,
    });
  };

  guardarEvaluacionMonitoreo = async (monitoreoId, evaluaciones) => {
    const ausenciaDemandaSeleccionada = Object.entries(evaluaciones).some(
      ([criterioId, valorTexto]) => {
        const criterio = this.props.criterios.find(
          (c) => c.criterioId === parseInt(criterioId)
        );

        return (
          valorTexto === "no_aplica" && esCriterioAusenciaDemanda(criterio)
        );
      }
    );

    if (ausenciaDemandaSeleccionada) {
      const evaluacionesCompletas = this.props.criterios.map((criterio) => ({
        monitoreoId: monitoreoId,
        criterioId: criterio.criterioId,
        resultado: Number(criterio.criterioId) === CRITERIO_AUSENCIA_DEMANDA_ID
          ? 1
          : 0,
      }));

      return await this.props.guardarMonitoreoEvaluacion(evaluacionesCompletas);
    }

    const evaluacionesCompletas = Object.entries(evaluaciones)
      .filter(([criterioId]) => {
        const criterio = this.props.criterios.find(
          (c) => c.criterioId === parseInt(criterioId)
        );

        return !esCriterioAusenciaDemanda(criterio);
      })
      .map(([criterioId, valorTexto]) => {
        const criterio = this.props.criterios.find(
          (c) => c.criterioId === parseInt(criterioId)
        );
        if (!criterio) {
          throw new Error(`No se encontro el criterio ${criterioId}`);
        }
        const resultadoNum = resultadoToNumber(valorTexto);

        let resultado = 0;
        if (resultadoNum === 2) resultado = criterio.valorMaximo;
        else if (resultadoNum === 1) resultado = criterio.valorMaximo / 2;

        return {
          monitoreoId: monitoreoId,
          criterioId: parseInt(criterioId),
          resultado,
        };
      });

    return await this.props.guardarMonitoreoEvaluacion(evaluacionesCompletas);
  };

  actualizarEvaluacionMonitoreo = async (monitoreoId, evaluaciones) => {
    const ausenciaDemandaSeleccionada = evaluaciones.some((item) => {
      const criterio = this.props.criterios.find(
        (c) => c.criterioId === item.criterioId
      );

      return (
        item.resultado === "no_aplica" && esCriterioAusenciaDemanda(criterio)
      );
    });

    if (ausenciaDemandaSeleccionada) {
      const evaluacionesCompletas = this.props.criterios.map((criterio) => {
        const evaluacionExistente = evaluaciones.find(
          (item) => item.criterioId === criterio.criterioId
        );

        return {
          monitoreoEvaluacionId:
            evaluacionExistente?.monitoreoEvaluacionId || 0,
          monitoreoId: monitoreoId,
          criterioId: criterio.criterioId,
          resultado: Number(criterio.criterioId) === CRITERIO_AUSENCIA_DEMANDA_ID
            ? 1
            : 0,
        };
      });

      return await this.props.actualizarMonitoreoEvaluacion(evaluacionesCompletas);
    }

    const evaluacionesCompletas = evaluaciones.map((item) => {
      const criterio = this.props.criterios.find(
        (c) => c.criterioId === item.criterioId
      );
      if (!criterio) {
        throw new Error(`No se encontro el criterio ${item.criterioId}`);
      }

      if (esCriterioAusenciaDemanda(criterio)) {
        return {
          monitoreoEvaluacionId: item.monitoreoEvaluacionId,
          monitoreoId: monitoreoId,
          criterioId: item.criterioId,
          resultado: 0,
        };
      }

      const resultadoNum = resultadoToNumber(item.resultado);

      let resultado = 0;
      if (resultadoNum === 2) resultado = criterio.valorMaximo;
      else if (resultadoNum === 1) resultado = criterio.valorMaximo / 2;

      return {
        monitoreoEvaluacionId: item.monitoreoEvaluacionId,
        monitoreoId: monitoreoId,
        criterioId: item.criterioId,
        resultado,
      };
    });
  
    return await this.props.actualizarMonitoreoEvaluacion(evaluacionesCompletas);
  };

  obtenerEvaluacionesPorMonitoreoId = async (monitoreoId) => {
    await this.props.getMonitereoEvaluacionCriteriosById(monitoreoId);
  };

  // Retornamos solo el número para poder evaluar el color
  obtenerPuntajeNumerico = (monitoreoId) => {
    const evaluaciones = this.props.monitoreoEvaluaciones || [];
    const filtrados = evaluaciones.filter(
      (ev) => ev.monitoreoId === monitoreoId
    );
    return filtrados.reduce(
      (acc, curr) => acc + (parseFloat(curr.resultado) || 0),
      0
    );
  };

  obtenerPuntuacionMonitoreo = (monitoreoId) => {
    const evaluaciones = this.props.monitoreoEvaluaciones || [];
    const filtrados = evaluaciones.filter(
      (ev) => ev.monitoreoId === monitoreoId
    );

    if (evaluacionEsAusenciaDemanda(filtrados, this.props.criterios)) {
      return {
        texto: "N/A",
        estilo: getSemaforoStyle(null),
      };
    }

    const puntaje = this.obtenerPuntajeNumerico(monitoreoId);

    return {
      texto: `${puntaje}%`,
      estilo: getSemaforoStyle(puntaje),
    };
  };

  recargarListaMonitoreo = async () => {
    const poaId =
      document.getElementById("anoSelected")?.value || this.props.poaActivo.poaId;
    const areaId =
      document.getElementById("areaSelected")?.value ||
      this.state.areaidSeleccionada ||
      this.props.user.areaOrganizacional.areaOrganizacionalId;

    this.setState({ isLoadingState: true });
    await this.props.getMonitereoEvaluadas();
    await this.props.getAdminMonitoreoActividad(poaId, areaId);
    this.setState({
      isLoadingState: false,
      adminMonitoreoActividadState: this.filtrarMonitoreosListado(
        this.props.adminMonitoreoActividad
      ),
    });
  };

  render() {
    const monitoreosEvaluados = new Set(
      (this.props.monitoreoEvaluaciones || []).map((x) =>
        Number(x.monitoreoId)
      )
    );

    const evaluacionesFiltradas =
      this.props.monitoreoEvaluaciones?.filter(
        (e) => e.monitoreoId === this.state.monitoreo?.monitoreoId
      ) || [];

    const esEdicion = evaluacionesFiltradas.length > 0;

    const poaSeleccionadoId = document.getElementById("anoSelected")?.value || this.props.poaActivo.poaId;
    const poaActual =
      this.props.poas.find(p => Number(p.poaId) === Number(poaSeleccionadoId)) ||
      (Number(this.props.poaActivo.poaId) === Number(poaSeleccionadoId)
        ? this.props.poaActivo
        : null);
    const esAno2026 = poaUsaPuntuacion(poaActual);

    return (
      <React.Fragment>
        <Container>
          <div className="pb-6 pt-5 pt-md-7">
            <div className=" bg-white border">
              {this.state.isLoadingState ? (
                <Loading></Loading>
              ) : (
                <React.Fragment>
                  <h3 className="pt-3 pl-3">Listado de Monitoreos</h3>
                  <div className="row" style={{ margin: "2%" }}>
                    <div className="col-md-4">
                      <label>Año del Poa</label>
                      <select
                        className="form-control"
                        defaultValue={this.props.poaActivo.poaId}
                        id="anoSelected"
                        ref={this.anoSelectedRef}
                        onChange={(e) => {
                          e.preventDefault();
                          this.setState({ isLoadingState: true });
                          this.cargarData(
                            document.getElementById("anoSelected").value,
                            document.getElementById("areaSelected").value
                          );
                        }}
                      >
                        {this.props.poas.map((poa) => (
                          <option key={poa.poaId} value={poa.poaId}>
                            {poa.ano}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label>Filtro Área</label>
                      <select
                        className="form-control"
                        defaultValue={this.state.areaidSeleccionada}
                        id="areaSelected"
                        onChange={(e) => {
                          e.preventDefault();

                          this.setState({ isLoadingState: true });
                        this.setState({areaidSeleccionada:document.getElementById("areaSelected").value});
                          this.cargarData(
                            document.getElementById("anoSelected").value,
                            document.getElementById("areaSelected").value
                          );
                        }}
                      >
                        {this.props.areaOrganizacionales.map((area) => (
                        <option key={area.areaOrganizacionalId} value={area.areaOrganizacionalId}>
                            {area.nombre}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="filtro">Filtro Productos </label>
                      <input style={{height:"60%"}}
                        type="text"
                        className="form-control form-control-sm text-dark"
                        id="filtro"
                        placeholder="Filtrar por Producto"
                        onKeyUp={(e) => {
                          e.preventDefault();
                          this.filtroProducto(e.currentTarget.value);
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    {this.state.adminMonitoreoActividadState.length > 0 ? (
                      <Table className="table-flush table-striped" responsive>
                        <thead>
                          <tr>
                            <th>Producto</th>
                            <th>Actividad</th>
                            <th>Trim.</th>
                            <th>Ejec.</th>
                            {/* 2. Cabecera condicional */}
                            {esAno2026 && <th>Puntuación</th>}
                            <th>M. Verificación</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.adminMonitoreoActividadState.map(
                            (monitoreo) => {
                              const monitoreoTieneEvaluacion =
                                monitoreosEvaluados.has(
                                  Number(monitoreo.monitoreoId)
                                );
                              const monitoreoAprobado =
                                monitoreo.aprobadoEnVista ||
                                this.monitoreoFueAprobado(monitoreo) ||
                                this.state.monitoreosAprobados.includes(
                                  monitoreo.monitoreoId
                                );
                              const monitoreoEvaluado =
                                monitoreoTieneEvaluacion;

                              return (
                              <tr key={monitoreo.monitoreoId}>
                                <td title={monitoreo.producto}>
                                  {truncateString(monitoreo.producto, 41)}
                                </td>
                                <td title={monitoreo.actividad}>
                                  {truncateString(monitoreo.actividad, 41)}
                                </td>
                                <td>{monitoreo.trimestre}</td>
                                <td>{monitoreo.nivelEjecucion}</td>
                                {/* Si el valor de puntuacion esta nulo, presentar el boton, de lo contrario; mostrar la puntuacion */}
                                {esAno2026 && (
                                <td>
                                  {monitoreoEvaluado ? (
                                    (() => {
                                      const puntuacion = this.obtenerPuntuacionMonitoreo(monitoreo.monitoreoId);
                                      return (
                                        <span style={puntuacion.estilo}>
                                          {puntuacion.texto}
                                        </span>
                                      );
                                    })()
                                  ) : (
                                    <button
                                      className="btn btn-warning btn-sm"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.activarModalCriteriosEvaluacionMonitoreo(monitoreo);
                                      }}
                                    >
                                      Evaluar
                                    </button>
                                  )}
                                </td>
                              )}
                                <td>
                                  <i
                                    className="btn fas fa-cloud-download-alt"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.cargarMonitoreoMediosVerificacion( monitoreo);
                                    }}
                                  />
                                </td>
                                <td className="d-flex gap-2">
                                  {esAno2026 && monitoreoEvaluado && (
                                    <button
                                      className="btn btn-sm btn-outline-warning"
                                      onClick={async (e) => {
                                        e.preventDefault();

                                        const evaluaciones =
                                          await this.obtenerEvaluacionesPorMonitoreoId(
                                            monitoreo.monitoreoId
                                          );

                                        this.activarModalCriteriosEvaluacionMonitoreo(
                                          monitoreo,
                                          evaluaciones
                                        );
                                      }}
                                    >
                                      Reevaluar
                                    </button>
                                  )}{" "}
                                  {monitoreoAprobado ? (
                                    <React.Fragment>
                                      <button
                                        className="btn btn-success btn-sm"
                                        disabled={true}
                                      >
                                        Aprobado
                                      </button>
                                      
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <button
                                        className="btn btn-primary btn-sm"
                                        disabled={
                                          esAno2026 ? !monitoreoEvaluado : false
                                        }
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.aprobarMonitoreo(monitoreo);
                                        }}
                                      >
                                        Aprobar
                                      </button>
                                    </React.Fragment>
                                  )}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.activarModalDevolucionMonitoreo(
                                        monitoreo
                                      );
                                    }}
                                  >
                                    Devolver
                                  </button>
                                </td>
                              </tr>
                            );
                            }
                          )}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="text-center my-5">
                        <h3>No existen monitoreos para aprobación</h3>
                      </div>
                    )}
                  </div>

                  <ModalArchivos
                    activarModalArchivos={this.activarModalArchivos}
                    state={this.state}
                    isLoadingModalArchivo={this.state.isLoadingModalArchivo}
                    modalArchivos={this.state.modalArchivos}
                    monitoreoMediosVerificacion={
                      this.state.monitoreoMediosVerificacion
                    }
                  ></ModalArchivos>

                  <ModalCriteriosEvaluacionMonitoreo
                    activarModalCriteriosEvaluacionMonitoreo={this.activarModalCriteriosEvaluacionMonitoreo}
                    modalCriteriosEvaluacion={this.state.modalCriteriosEvaluacion}
                    monitoreo={this.state.monitoreo}
                    criteriosEvaluacionMonitoreo={this.CriteriosEvaluacionMonitoreo}
                    criterios={this.props.criterios}
                    guardarEvaluacionMonitoreo={this.guardarEvaluacionMonitoreo}
                    actualizarEvaluacionMonitoreo={this.actualizarEvaluacionMonitoreo}
                    recargarLista={this.recargarListaMonitoreo}
                    evaluaciones={this.props.monitoreoEvaluacion}
                    modo={esEdicion ? "editar" : "crear"}
                  />

                  <ModalDevolucionMonitoreo
                    activarModalDevolucionMonitoreo={
                      this.activarModalDevolucionMonitoreo
                    }
                    modalDevolucion={this.state.modalDevolucion}
                    monitoreo={this.state.monitoreo}
                    devolverMonitoreo={this.devolverMonitoreo}
                  ></ModalDevolucionMonitoreo>
                </React.Fragment>
              )}
            </div>
          </div>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    poaActivo: state.poas.poaActivo,
    user: state.auth.signed,
    poas: state.poas.poas,
    adminMonitoreoActividad: state.monitoreosActividad.adminMonitoreoActividad,
    monitoreoMediosVerificacion:
      state.monitoreoMediosVerificacion.monitoreoMediosVerificacion,
    areaOrganizacionales: state.areasOrganizacionales.areasOrganizacionales,//me
    criterios: state.criterios.criterios,
    monitoreoEvaluaciones: state.monitoreoEvaluaciones.monitoreoEvaluaciones,
    monitoreoEvaluacion: state.monitoreoEvaluaciones.monitoreoEvaluacion,
  }
);

const mapDispatchToProps = (dispatch) => ({
  getAdminMonitoreoActividad: (poaId,area) => dispatch(getAdminMonitoreoActividad(poaId,area)),
  getMonitoreoActividad: (monitoreoId) => dispatch(getMonitoreoActividad(monitoreoId)),
  updateMonitoreoActividad: (monitoreoActividad) =>  dispatch(updateMonitoreoActividad(monitoreoActividad)),
  getPoaActivo: () => dispatch(getPoaActivo()),
  mostrarPoas: () => dispatch(mostrarPoas()),
  mostrarPoa: (poaId) => dispatch(mostrarPoa(poaId)),
    getListMonitoreoMediosVerificacion:(monitoreoId)=>dispatch(getListMonitoreoMediosVerificacion(monitoreoId)),
  getAreasOrganizacionales: () => dispatch(getAreasOrganizacionales()),//me
  getCriterios: () => dispatch(getCriterios()),
  getMonitereoEvaluadas: () => dispatch(getMonitereoEvaluadas()),
  guardarMonitoreoEvaluacion: (evaluacion) =>
    dispatch(guardarMonitoreoEvaluacion(evaluacion)),
  actualizarMonitoreoEvaluacion: (evaluacion) =>
    dispatch(actualizarMonitoreoEvaluacion(evaluacion)),
  getMonitereoEvaluacionCriteriosById: (monitoreoId) =>
    dispatch(getMonitereoEvaluacionCriteriosById(monitoreoId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  Authorization(AreaMonitoreo, [
    "Administrador general",
    "Analista del POA",
    "MAE",
  ])
);
